<template>
  <div class="shopcar content_center"
       v-loading="loading"
       element-loading-spinner="el-icon-loading">
    <p class="common_title_shopcar">购物车</p>
    <div class="delbtn-container">
      <el-button type="danger" size="small" @click="delGoods">删除</el-button>
    </div>
    <div v-if="shopcarLists">
      <el-table :header-cell-style="{fontSize:'13px',color: '#787878',background: '#F5F5F5',textAlign:'center'}"
                :cell-style="{fontSize:'14px',textAlign:'center',padding:'20px 0px'}"
                v-for="(item,index) in shopcarLists"
                :key="index"
                ref="shopcarId"
                :row-key="getRowKey"
                :row-class-name="tableRowClassName"
                :data="item"
                tooltip-effect="dark"
                style="width: 100%">
        <el-table-column :reserve-selection="true"
                        :selectable="selectable"
                         type="selection">
        </el-table-column>
        <el-table-column label="商品名称"
                         width="240">
          <template slot-scope="scope">
            <div class="flex">
              <div><img width="90px"
                     height="90px"
                     :src="scope.row.imgUrl ? scope.row.imgUrl : noPic"
                     alt=""></div>
              <div class="ml10 ml10 overflow_ellipsis2 textleft"
                   style="height:40px;">
                <p>{{scope.row.productName}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsCode"
                         label="商品编码">
        </el-table-column>
        <el-table-column label="商品类型">
          <template slot-scope="scope">
            <p class="ml10 ml10 overflow_ellipsis2">{{setProductType(scope.row.productType)}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="spec"
                         label="规格">
        </el-table-column>
        <el-table-column prop="saleUnitName"
                         label="单位">
        </el-table-column>
        <el-table-column prop="price"
                         label="单价">
          <template slot-scope="scope">
            <p>{{scope.row.price || 0.00}}</p>
          </template>
        </el-table-column>
        <el-table-column width="150px"
                         label="数量">
          <template slot-scope="scope">
            <div>
              <el-input-number 
                size="mini"
                :min="1"
                v-model="scope.row.num"
                label="数量">
              </el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计">
          <template slot-scope="scope">
            <span>{{scope.row.price*scope.row.num || 0}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <p @click="detorder(scope.row.id)" -->
            <p @click="detorder(scope.row.deleteId)"
               class="el-icon-delete cursorP"
               style="font-size:16px;"></p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else
         class="notproList textcenter mtb20">
      <img src="@/assets/img/no_goods.png"
           alt="">
      <p class="ft18 C5C5C5">暂无商品</p>
    </div>
    <div class="shop_car_bottom">
      <el-button @click="goHOme"
                 size="size"
                 type="text">返回上一页</el-button>
      <el-button @click="goshopproduct"
                 size="size"
                 class="ml10"
                 type="primary">去下单</el-button>
    </div>
  </div>
</template>
<script>
/**
 * @description:  接口
 * @param {*} ShoppingcartList 获取购物车列表
 * @param {*} mdmdictdata 字典查询商品的类型
 * @param {*} mdmdictdata 字典查询商品的类型
 * @param {*} delByIds 删除订单
 * @return {*}
 * @author: txp
 */
import { ShoppingcartList, mdmdictdata, delByIds } from "@/api/api";
import { Storage } from "@/utils/storage";
import noPic from '@/assets/img/no_goods.png';
export default {
  data() {
    return {
      loading: true,
      num: 1,
      producttype: [],
      shopcarLists: {},
      noPic
    };
  },
  created() {
    this.mdmdictdatas();
    this.ShoppingcartLists();
  },
  methods: {
    tableRowClassName({ row }) {
      // console.log(row);
      if (!row.goodsInfo) {
        return "warning-row";
      }
      return "";
    },
    selectable(row){
      if (row.goodsInfo){
        return true
      }
      return false
    },
    getRowKey(row) {
      return row.id;
    },
    /**
     * @description: 获取商品类型字典
     * @param {*}
     * @return {Array} 商品类型
     * @author: txp
     */
    mdmdictdatas() {
      mdmdictdata({ dictTypeCode: "product_type" }).then(res => {
        this.producttype = res.result;
      });
    },
    // 筛选类型
    setProductType(type) {
      if (type) {
        let typevalue = this.producttype.find(item => {
          if (item.dictCode === type) {
            return item.dictValue;
          }
        });
        return typevalue.dictValue;
      } else {
        return "";
      }
    },
    /**
     * @description: 购物车产品列表
     * @param {*}
     * @param {*}
     * @return {Object}
     * @author: txp
     */
    ShoppingcartLists() {
      ShoppingcartList()
        .then(res => {
          if (res.code == 200 && res.result) {
            const shopcarLists = {};
            for (const i in res.result) {
              if (res.result[i]) {
                const list = [];
                res.result[i].forEach(v => {
                  const imgUrl = v.goodsInfo
                    ? v.goodsInfo.pictureList
                      ? JSON.parse(v.goodsInfo.pictureList)
                      : []
                    : [];
                  list.push({
                    ...v,
                    ...v.goodsInfo,
                    deleteId: v.id,//删除需要的id
                    imgUrl: imgUrl[0] ? imgUrl[0].urlAddress : "",
                    productName: v.goodsName
                  });
                });
                shopcarLists[i] = list;
              }
            }
            this.shopcarLists = shopcarLists;
            console.log(shopcarLists);

            this.loading = false;
          } else {
            this.shopcarLists = [];
          }
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    /**
     * @description:删除订单
     * @param {*} 数组id
     * @return {*}
     * @author: txp
     */
    detorder(id) {
      delByIds([id])
        .then(res => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.ShoppingcartLists();
          }
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    /**
     * @description: 去下单 需求：可以选择多个公司的产品，下单只能购买同一个公司的产品  通过refs获取到选中的table个数，flage来判断选中的公司 ，selectArr获取接受选择的值
     * @param {*}  selectArr 获取选择的值
     * @return {*}
     * @author: txp
     */
    goshopproduct() {
      let flag = 0;
      let selectArr = [];
      if (this.$refs.shopcarId.length > 0) {
        this.$refs.shopcarId.forEach((item, index) => {
          if (item.selection.length > 0) {
            selectArr = item.selection;
            flag++;
          }
        });
      }
      if (flag >= 2) {
        this.$message.error("请选择同一个公司产品");
        return;
      } else if (selectArr.length > 0) {
        const dataList = [];
        selectArr.map(item => {
          let obj = {
            ...item.goodsInfo,
            productNum: item.num,
            isChecked: true,
            lineType: "10",
            imgUrl: item.imgUrl
          };
          dataList.push(obj);
        });
        Storage.l.set("orderList", JSON.stringify(dataList));
        this.$router.push({
          path: "/home/shopsesttle"
        });
      } else {
        this.$message.error("请选择购买商品");
      }
    },
    // 返回上一页
    goHOme() {
      window.history.back();
    },
    //删除商品
    delGoods() {
      let selectArr = [];
      if (this.$refs.shopcarId.length > 0) {
        this.$refs.shopcarId.forEach((item, index) => {
          if (item.selection.length > 0) {
            selectArr = item.selection;
          }
        });
      }
      console.log(selectArr)
      if(selectArr.length === 0) {
        this.$message.error("请选择删除的商品");
      }else {
        const ids = selectArr.map(item=>item.deleteId)
        delByIds(ids)
        .then(res => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.ShoppingcartLists();
          }
        })
        .catch(error => {
          this.$message.error(error);
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.shopcar {
  .delbtn-container{
    display: flex;
    justify-content: flex-end;
  }
  .common_title_shopcar {
    font-size: 28px;
    color: #1d1d1d;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .shop_car_bottom {
    padding: 15px;
    margin: 20px 0px;
    background-color: #f5f5f5;
    text-align: right;
    /deep/ .el-button {
      width: 120px;
    }
  }
  /deep/ .el-table {
    margin: 20px 0px;
    td {
      vertical-align: top;
    }
    .el-table-column--selection {
      font-size: 14px;
    }

    // .el-input-number--small{
    //   height: 28px;
    //   .el-input__inner{
    //     height: 26px;
    //   }
    //   .el-input-number__decrease{
    //     height: 26px;
    //   }

    // }
  }
}
/deep/.warning-row{
  color: red;
}
</style>